// Logo served from public/ (stable, non-hashed URL) so the browser can
// cache it with long-term Cache-Control headers from public/_headers.
// WebP is ~10x smaller than the original PNG, dramatically improving FCP.
// Explicit width/height prevent CLS (unsized-images Lighthouse audit).
const LOGO_SRC_SM = "/sg-logo-brand-sm.webp"; // ~300px wide, ideal for header
const LOGO_SRC_WEBP = "/sg-logo-brand.webp"; // full-res fallback
const LOGO_SRC_PNG = "/sg-logo-brand.png";
const LOGO_NATURAL_W = 1920;
const LOGO_NATURAL_H = 548;
// Small version dimensions (from edit_image output, ~1536×512 → 3:1)
const SM_W = 1536;

interface SGLogoProps {
  className?: string;
  height?: number;
  dark?: boolean;
}

const SGLogo = ({ className = "", height = 48, dark = true }: SGLogoProps) => {
  // Calculate the rendered width from the natural aspect ratio so the browser
  // can reserve the correct space before the image loads, eliminating CLS.
  const renderedW = Math.round((height / LOGO_NATURAL_H) * LOGO_NATURAL_W);

  return (
    <picture>
      {/* Small WebP is sufficient for all header sizes; full-res never needed */}
      <source srcSet={LOGO_SRC_SM} type="image/webp" />
      <img
        src={LOGO_SRC_SM}
        alt="Shiksha Guide – Your Compass To Success"
        className={className}
        draggable={false}
        width={renderedW}
        height={height}
        style={{
          height: `${height}px`,
          width: "auto",
          maxWidth: "100%",
          objectFit: "contain",
          mixBlendMode: dark ? "screen" : "normal",
          display: "block",
        }}
      />
    </picture>
  );
};

export default SGLogo;

